<mat-card>
  <h2 translate>Calculator</h2>
  <mat-card-content>
    <p translate>request.calculator.subtitle</p>
  </mat-card-content>
</mat-card>
